import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { M8GroupedClientStack, M8StackType } from 'services/production/types';
import { getM8AdminURL } from 'services/production/utils/getM8URL';

export const getGroupClientStacks = async (
  stackType: M8StackType
): Promise<M8GroupedClientStack[]> => {
  const response = await customFetch(
    getM8AdminURL(`getGroupClientStacks?stackType=${stackType}`),
    { method: 'GET' }
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
